import { useRef } from 'react';
import { NavMarker } from 'react-rhumb';
import getLangLocale from 'I18n/utils/getLangLocale';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Spacer from 'unsubscribe-ui/components/core/layout/Spacer';
import StickyFooter from 'unsubscribe-ui/components/core/layout/StickyFooter';
import Actions from 'unsubscribe-ui/components/managePreferences/Actions';
import DefinitionList from 'unsubscribe-ui/components/managePreferences/subscriptionList';
import useScrollCheck from 'unsubscribe-ui/hooks/useScrollCheck';
import useManagePreferences from 'unsubscribe-ui/hooks/managePreferencesHooks/useManagePreferences';
import useGetSubscriptionDefinition from 'unsubscribe-ui/hooks/managePreferencesHooks/useGetSubscriptionDefinitions';
import { ContentPanel, GridPanel } from 'unsubscribe-ui/components/core/layout/Content';
import Headings from '../core/typography/Heading';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ManagePreferencesPage = ({
  userPreferences
}) => {
  const {
    subscriptionStatuses,
    email,
    company,
    languages
  } = userPreferences;
  const actionRef = useRef(null);
  const hasScroll = useScrollCheck(actionRef);
  const subscriptionDefinitions = useGetSubscriptionDefinition(subscriptionStatuses, getLangLocale());
  const {
    subscriptionStates,
    onSubscriptionChange,
    onClickManagePreference,
    onClickUnsubscribeAll
  } = useManagePreferences(userPreferences);
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "MANAGE_PREFERENCES_LOAD",
    children: [/*#__PURE__*/_jsxs(ContentPanel, {
      languages: languages,
      company: company,
      children: [/*#__PURE__*/_jsx(Headings, {
        variant: "heading-400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "preferences.title"
        })
      }), /*#__PURE__*/_jsx(Spacer, {
        marginBlock: "100"
      }), /*#__PURE__*/_jsx(Headings, {
        variant: "heading-100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "preferences.subTitle",
          options: {
            contactEmail: email
          }
        })
      }), /*#__PURE__*/_jsx(Spacer, {
        marginBlock: "400"
      }), /*#__PURE__*/_jsx(DefinitionList, {
        subscriptionDefinitions: subscriptionDefinitions,
        subscriptionStates: subscriptionStates,
        onSubscriptionChange: onSubscriptionChange
      })]
    }), /*#__PURE__*/_jsx(StickyFooter, {
      mobile: hasScroll,
      children: /*#__PURE__*/_jsx("div", {
        ref: actionRef,
        children: /*#__PURE__*/_jsx(GridPanel, {
          children: /*#__PURE__*/_jsx(Actions, {
            onClickManagePreference: onClickManagePreference,
            onClickUnsubscribeAll: onClickUnsubscribeAll
          })
        })
      })
    })]
  });
};
export default ManagePreferencesPage;